import React, {useState} from 'react'
import {Dropdown, DropdownMenu, DropdownToggle} from 'reactstrap'


const MeetingStatusFilter = ({meetings, selectedStatuses, onChange = () => true, ...props}) => {

    const statuses = TB.filter([...laravel.meeting_statuses], status => status !== 'Past');
    const [menuOpen, setMenuOpen] = useState(false);

    const meetingStatusCount = TB.countBy(meetings, 'status');

    return (
        <Dropdown
            className="ml-auto"
            isOpen={menuOpen}
                  toggle={() => setMenuOpen(!menuOpen)}>

            <DropdownToggle tag="button"
                            className="btn btn-white btn-outline-dark ml-auto">
                <i className="fas fa-filter"></i>
            </DropdownToggle>


            <DropdownMenu right={true}>

                <div className="flex flex-col items-stretch">
                    {statuses.map(status => {
                        const isDisabled = false;//!meetingStatusCount[status];
                        let isSelected = selectedStatuses.includes(status);

                        let inputID = "checkbox" + status;
                        return (
                            <div key={inputID} className={TB.mapClass("no-bg form-checkbox", {
                                "disabled-checkbox": isDisabled
                            })}>
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name={inputID}
                                    id={inputID}
                                    required={false}
                                    disabled={isDisabled}
                                    onChange={() => onChange(TB.xor(selectedStatuses, [status]))}
                                    checked={isSelected}
                                />

                                <label className="whitespace-no-wrap form-check-label flex-grow" htmlFor={inputID}>
                                    {status}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </DropdownMenu>
        </Dropdown>
    )
}

export default MeetingStatusFilter;